import FooterButtons from 'core/modules/compositions/FooterButtons';
import PropTypes from 'prop-types';
import React from 'react';

const HeaderSave = ({ buttonTextCancel, buttonTextSucess, onSuccess, onCancel, disabledSuccess }) => {
  return (
    <div className="header-save">
      <div className="header-save__grid">
        <div className=""></div>
        <div className="header-save__buttons-right">
          <FooterButtons
            disabledSuccess={disabledSuccess}
            buttonTextCancel={buttonTextCancel ? buttonTextCancel : null}
            buttonTextSucess={buttonTextSucess ? buttonTextSucess : null}
            onSuccess={onSuccess ? onSuccess : null}
            onCancel={onCancel ? onCancel : null}
          />
        </div>
      </div>
    </div>
  );
};

HeaderSave.propTypes = {
  buttonTextCancel: PropTypes.string,
  buttonTextSucess: PropTypes.string,
  disabledSuccess: PropTypes.bool,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
};

HeaderSave.defaultProps = {
  buttonTextCancel: 'Cancel',
  buttonTextSucess: 'Success',
  disabledSuccess: false,
};

export default HeaderSave;
